export default __webpack_public_path__ + "static/media/GIC_Client_Swatch_Instructions_2.d7ee12ed.pdf";